import { render } from "./manage-info.vue?vue&type=template&id=4a55e5c0&scoped=true&ts=true"
import script from "./manage-info.vue?vue&type=script&lang=ts"
export * from "./manage-info.vue?vue&type=script&lang=ts"

import "./manage-info.vue?vue&type=style&index=0&id=4a55e5c0&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a55e5c0"]])

export default __exports__